/**
 * Which launches play the full show: your first ten games, then big boxes and epics (or always / never).
 * Decided before the reviews are read, so the show never gives away a hit.
 */
export function launchShowPref(): "auto" | "always" | "never" {
  try {
    const v = localStorage.getItem("bd:launchShow");
    return v === "always" || v === "never" ? v : "auto";
  } catch {
    return "auto";
  }
}

export function setLaunchShowPref(v: "auto" | "always" | "never") {
  try {
    localStorage.setItem("bd:launchShow", v);
  } catch {
    // storage blocked: the setting lasts until the page closes
  }
}

export function wantsLaunchShow(released: number, scope: string | undefined): boolean {
  const pref = launchShowPref();
  if (pref === "never") return false;
  if (pref === "always") return true;
  return released <= 10 || scope === "big" || scope === "epic";
}
